import { GetterTree } from 'vuex'
import { RootState } from 'store'
import { SettingState } from './types'

export const getters: GetterTree<SettingState, RootState> = {
    payLocationCount: (state: SettingState) => state.paylocationCount,
    settings: (state: SettingState) => state.settings,
}